export const BULLET_SIZE = 24;
